import { makeAutoObservable } from 'mobx';

export default class CityNewsStore {
    constructor() {
        this._cityNews = [];
        this._committeeMeetings = [];
        this._photoGallery = [];
        this._onlineMeetings = [];
        this._mayorOnline = [];

        this._other = [];
        this._cityNewsPage = 1;
        this._committeeMeetingsPage = 1;
        this._photoGalleryPage = 1;
        this._onlineMeetingsPage = 1;
        this._mayorOnlinePage = 1;
        this._otherPage = 1;

        this._cityNewsTotalCount = 0;
        this._committeeMeetingsTotalCount = 0;
        this._photoGalleryTotalCount = 0;
        this._onlineMeetingsTotalCount = 0;
        this._mayorOnlineTotalCount = 0;
        this._otherTotalCount = 0;

        this._cityNewsLimit = 6;
        this._committeeMeetingsLimit = 6;
        this._photoGalleryLimit = 6;
        this._onlineMeetingsLimit = 6;
        this._mayorOnlineLimit = 6;
        this._otherLimit = 6;

        makeAutoObservable(this);
    }

    setCityNews(cityNews) {
        this._cityNews = cityNews;
    }
    get cityNews() {
        return this._cityNews;
    }

    setCommitteeMeetings(committeeMeetings) {
        this._committeeMeetings = committeeMeetings;
    }
    get committeeMeetings() {
        return this._committeeMeetings;
    }

    setPhotoGallery(photoGallery) {
        this._photoGallery = photoGallery;
    }
    get photoGallery() {
        return this._photoGallery;
    }

    setOnlineMeetings(onlineMeetings) {
        this._onlineMeetings = onlineMeetings;
    }
    get onlineMeetings() {
        return this._onlineMeetings;
    }

    setMayorOnline(mayorOnline) {
        this._mayorOnline = mayorOnline;
    }
    get mayorOnline() {
        return this._mayorOnline;
    }

    setOther(other) {
        this._other = other;
    }
    get other() {
        return this._other;
    }

    setCityNewsPage(page) {
        this._cityNewsPage = page;
    }
    get cityNewsPage() {
        return this._cityNewsPage;
    }

    setCommitteeMeetingsPage(page) {
        this._committeeMeetingsPage = page;
    }

    get committeeMeetingsPage() {
        return this._committeeMeetingsPage;
    }

    setPhotoGalleryPage(page) {
        this._photoGalleryPage = page;
    }

    get photoGalleryPage() {
        return this._photoGalleryPage;
    }

    setOnlineMeetingsPage(page) {
        this._onlineMeetingsPage = page;
    }

    get onlineMeetingsPage() {
        return this._onlineMeetingsPage;
    }

    setMayorOnlinePage(page) {
        this._mayorOnlinePage = page;
    }

    get mayorOnlinePage() {
        return this._mayorOnlinePage;
    }

    setOtherPage(page) {
        this._otherPage = page;
    }

    get otherPage() {
        return this._otherPage;
    }

    setCityNewsTotalCount(count) {
        this._cityNewsTotalCount = count;
    }
    get cityNewsTotalCount() {
        return this._cityNewsTotalCount;
    }

    setCommitteeMeetingsTotalCount(count) {
        this._committeeMeetingsTotalCount = count;
    }
    get committeeMeetingsTotalCount() {
        return this._committeeMeetingsTotalCount;
    }

    setPhotoGalleryTotalCount(count) {
        this._photoGalleryTotalCount = count;
    }
    get photoGalleryTotalCount() {
        return this._photoGalleryTotalCount;
    }

    setOnlineMeetingsTotalCount(count) {
        this._onlineMeetingsTotalCount = count;
    }
    get onlineMeetingsTotalCount() {
        return this._onlineMeetingsTotalCount;
    }

    setMayorOnlineTotalCount(count) {
        this._mayorOnlineTotalCount = count;
    }
    get mayorOnlineTotalCount() {
        return this._mayorOnlineTotalCount;
    }

    setOtherTotalCount(count) {
        this._otherTotalCount = count;
    }
    get otherTotalCount() {
        return this._otherTotalCount;
    }

    setCityNewsLimit(limit) {
        this._cityNewsLimit = limit;
    }

    get cityNewsLimit() {
        return this._cityNewsLimit;
    }

    setCommitteeMeetingsLimit(limit) {
        this._committeeMeetingsLimit = limit;
    }

    get committeeMeetingsLimit() {
        return this._committeeMeetingsLimit;
    }

    setPhotoGalleryLimit(limit) {
        this._photoGalleryLimit = limit;
    }

    get photoGalleryLimit() {
        return this._photoGalleryLimit;
    }

    setOnlineMeetingsLimit(limit) {
        this._onlineMeetingsLimit = limit;
    }

    get onlineMeetingsLimit() {
        return this._onlineMeetingsLimit;
    }

    setMayorOnlineLimit(limit) {
        this._mayorOnlineLimit = limit;
    }

    get mayorOnlineLimit() {
        return this._mayorOnlineLimit;
    }

    setOtherLimit(limit) {
        this._otherLimit = limit;
    }

    get otherLimit() {
        return this._otherLimit;
    }
}
